module["exports"] = [
  "Västra",
  "Östra",
  "Norra",
  "Södra",
  "Övre",
  "Undre"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/street_prefix.js
// module id = 2730
// module chunks = 2